<template>
  <v-container
    class="appearance-widget-two-column pa-0 ma-0"
    fluid
    fill-height
    align-center
    justify-center
  >
    <v-layout fluid row >
      <v-flex md5 class='border-right'>
        <v-layout class="pa-0 ma-0 mt-3 section" column>
          <v-flex md5 class="section-header">
          GENERAL
          </v-flex>
          <v-layout fluid column class='section-content'>
            <v-flex class="text-input-container limit-width">
              <label> Brand/Product Name </label>
              <v-text-field
                      class="lg-text-field"
                v-model="formData.brandName"
                solo
                v-validate="'required|max:50'"
                :error-messages="errors.collect('Brand/Product Name')"
                data-vv-name="Brand/Product Name"
                counter="50"
              ></v-text-field>
            </v-flex>
            <v-flex class="text-input-container limit-width">
              <label>Survey Language </label>
              <v-select
                      class="lg-select"
                :items="languages"
                item-text="label"
                item-value="id"
                solo
                v-model="formData.language"
                @change="$emit('change', formData)"
              ></v-select>
            </v-flex>
            <v-flex class="text-input-container limit-width">
              <label> Brand Color </label>
              <v-input v-model="formData.brandColor" solo>
                <verte picker="square" model="hex" v-model="formData.brandColor"
                  ><v-layout class="color-input-wrapper">
                    <v-flex class="color-preview" :style="previewColor"></v-flex>
                    <input type="text" v-model="formData.brandColor" /> </v-layout
                ></verte>
              </v-input>
            </v-flex>
          </v-layout>
          
        </v-layout>
        <v-layout class='pa-0 ma-0 mt-5 section' column @mouseover="previewItem='FEEDBACK_WIDGET'">
          <v-flex class="section-header">
            FEEDBACK WIDGET
          </v-flex>
          <v-flex class=" section-content">
            <v-flex class="text-input-container">
            <label> Widget Position </label>
            <v-layout class="widget-positions">
              <v-flex
                class="widget-position"
                :class="{ selected: formData.widgetPosition === 'BOTTOM' }"
                @click="formData.widgetPosition = 'BOTTOM'"
              >
                <div
                  class="position bottom"
                  :style="selectedWidgetPositionStyle('BOTTOM')"
                >
                </div>
                <div class="position-label">
                  Bottom Full
                </div>
              </v-flex>
              <v-flex
                class="widget-position"
                :class="{ selected: formData.widgetPosition === 'TOP' }"
                @click="formData.widgetPosition = 'TOP'"
              >
                <div
                  class="position top"
                  :style="selectedWidgetPositionStyle('TOP')"
                ></div>
                <div class="position-label">Top Full</div>
              </v-flex>
              <v-flex
                class="widget-position"
                :class="{ selected: formData.widgetPosition === 'BOTTOM_CENTRE' }"
                @click="formData.widgetPosition = 'BOTTOM_CENTRE'"
              >
                <div
                  class="position bottom-centre"
                  :style="selectedWidgetPositionStyle('BOTTOM_CENTRE')"
                ></div>
                <div class="position-label">Bottom Center</div>
              </v-flex>
              <v-flex
                class="widget-position"
                :class="{ selected: formData.widgetPosition === 'TOP_CENTRE' }"
                @click="formData.widgetPosition = 'TOP_CENTRE'"
              >
                <div
                  class="position top-centre"
                  :style="selectedWidgetPositionStyle('TOP_CENTRE')"
                ></div>
                <div class="position-label">Top Center</div>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="mt-3 switch-input limit-width" 
            v-if="showAnimationSettings"
            :class="{'enabled': formData.widgetAnimations}">
            <v-layout align-center >
              <v-flex>
                <label>Animations</label>
              </v-flex>
              <v-flex>
              <v-layout align-center style="width: 75px">
                <v-switch
                  class="lg-switch"
                  :ripple="false"
                  v-model="formData.widgetAnimations"
                ></v-switch>
                <label class="switch-status-label" >{{ formData.widgetAnimations ? "Yes" : "No" }}</label>
              </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex class="mt-3 switch-input limit-width"
          v-if="showPoweredBySettings"
          :class="{'enabled': formData.poweredBy}">
            <v-layout align-center >
              <v-flex>
                <label>Powered by</label>
              </v-flex>
              <v-flex>
                <v-layout align-center style="width: 75px">
                  <v-switch
                    class="lg-switch"
                    :ripple="false"
                    v-model="formData.poweredBy"
                  ></v-switch>
                  <label class="switch-status-label" >{{ formData.poweredBy ? "Yes" : "No" }}</label>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          </v-flex>
        </v-layout>
        <v-layout class='section pa-0 ma-0 mt-5 section' column @mouseover="previewItem='FEEDBACK_BUTTON'">
          <v-flex  class="section-header pb-0">
            FEEDBACK BUTTON
          </v-flex>
          <v-layout class="section-content" fluid column >
            <v-flex class="switch-input limit-width"  
              v-if="showAnimationSettings"
              :class="{'enabled': formData.buttonEnabled}">
              <v-layout align-center >
                <v-flex>
                  <label>Enabled</label>
                </v-flex>
                <v-flex>
                <v-layout align-center style="width: 75px">
                  <v-switch
                    class="lg-switch"
                    :ripple="false"
                    v-model="formData.buttonEnabled"
                  ></v-switch>
                  <label class="switch-status-label" >{{ formData.buttonEnabled ? "Yes" : "No" }}</label>
                </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex class="text-input-container limit-width">
              <label> Label </label>
              <v-text-field
                      class="lg-text-field"
                      v-model="formData.buttonLabel"
                solo
                v-validate="'required|max:15'"
                :error-messages="errors.collect('Button label')"
                data-vv-name="Button Label"
                counter="15"
              ></v-text-field>
            </v-flex>
            <v-flex class="text-input-container">
              <label> Button Position </label>
              <v-layout class="button-positions">
                <v-flex
                  class="button-position"
                  :class="{ selected: formData.buttonPosition === 'RIGHT_CENTER' }"
                  @click="formData.buttonPosition = 'RIGHT_CENTER'"
                >
                  <div
                    class="position right-center"
                    :style="selectedButtonPositionStyle('RIGHT_CENTER')"
                  >
                  </div>
                  <div class="position-label">
                    Right Center
                  </div>
                </v-flex>
                <v-flex
                  class="button-position"
                  :class="{ selected: formData.buttonPosition === 'LEFT_CENTER' }"
                  @click="formData.buttonPosition = 'LEFT_CENTER'"
                >
                  <div
                    class="position left-center"
                    :style="selectedButtonPositionStyle('LEFT_CENTER')"
                  ></div>
                  <div class="position-label">Left Center</div>
                </v-flex>
                
                <v-flex
                  class="button-position"
                  :class="{ selected: formData.buttonPosition === 'BOTTOM_RIGHT' }"
                  @click="formData.buttonPosition = 'BOTTOM_RIGHT'"
                >
                  <div
                    class="position bottom-right"
                    :style="selectedButtonPositionStyle('BOTTOM_RIGHT')"
                  ></div>
                  <div class="position-label">Bottom Right</div>
                </v-flex>
                <v-flex
                  class="button-position"
                  :class="{ selected: formData.buttonPosition === 'BOTTOM_LEFT' }"
                  @click="formData.buttonPosition = 'BOTTOM_LEFT'"
                >
                  <div
                    class="position bottom-left"
                    :style="selectedButtonPositionStyle('BOTTOM_LEFT')"
                  ></div>
                  <div class="position-label">Bottom Left</div>
                </v-flex>
              </v-layout>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center class="mt-5">
              <v-btn
                class="btn-next"
                color="accent"
                medium
                depressed=""
                style="max-width: 150px"
                @click="next"
              >
                {{ $t('next_step') }}
              </v-btn>
            </v-layout>
        </v-layout>
        
      </v-flex>
      <v-flex md7 >
        <v-container fill-height>
          <BrowserWireframe :buttonPosition="formData.buttonPosition"
                            :buttonVisible="formData.buttonEnabled"
                            :brandColor="formData.brandColor"
                            :feedbackWidgetVisible="true"
                            :proofWidgetVisible="false"
                            :feedbackWidgetPosition="formData.widgetPosition"
                            :previewItem="previewItem"></BrowserWireframe>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import formMixins from '@/mixins/forms'
import Verte from 'verte'
import 'verte/dist/verte.css'
import BrowserWireframe from './BrowserWireframe.vue'
import SingleChoiceQuestion from '../../../widgets/feedback/src/components/SingleChoiceQuestion.vue'
import EventBus from '@/event_bus'
export default {
  mixins: [formMixins],
  components: { Verte, BrowserWireframe },
  name: 'AppearanceWidgetTwoColumn',
  props: {
    campaign: {
      type: Object,
      default: function() {
        return {
          brandName: '',
          brandColor: '#132968',
          language: 'en',
          widgetPosition: 'BOTTOM',
          widgetAnimations: true,
          poweredBy: true,
          buttonEnabled: false,
          buttonPosition: "RIGHT_CENTER",
          buttonLabel: ''
        }
      }
    },
    showAnimationSettings: { type: Boolean, default: true },
    showPoweredBySettings: { type: Boolean, default: true }
  },
  data: function() {
    return {
      formData: this.campaign,
      languages: [{ id: 'en', label: 'English' }],
      previewItem: 'FEEDBACK_WIDGET', // FEEDBCK_BUTTON
    }
  },
  computed: {
    previewColor: function() {
      
      return { background: this.formData.brandColor }
    }
  },
  watch: {
    formData: {
      handler: function(val) {
        if (this.isFormValid) {
          this.$emit('change', this.campaign)
        }
      },
      deep: true
    }
  },
  methods: {
    selectedWidgetPositionStyle: function(pos) {
      if (pos === this.formData.widgetPosition) {
        return {
          background: this.formData.brandColor
        }
      }
      return {}
    },
    selectedButtonPositionStyle: function(pos) {
      console.log(pos, this.formData.buttonPosition)
      if (pos === this.formData.buttonPosition) {
        return {
          background: this.formData.brandColor
        }
      }
      return {}
    },
    next(){
      EventBus.$emit('SURVEY_NEXT')
    }
  }
}
</script>

<style lang="stylus">
.appearance-widget-two-column {
  .border-right {
    border-right: 1px solid #F1F2F6;
  }
  .section {

  }
  .section-header {
    padding-bottom: 25px
    font-weight: 500;
    font-size: 14px;
    color: $color-primary-light-5;
  }

  .section-content {
    padding-left: 40px
  }

    .text-input-container {
        margin-bottom 10px
        
    }
    .limit-width {
      max-width: 200px !important
    }
    .lg-text-field {
        input {
            font-size 14px
        }
    }

    .lg-select {
        .v-select__selection {
            font-size 14px
        }
    }

    .color-preview {
        min-width: 40px;
        max-width: 40px;
        height: 40px;
        border-top-left-radius 5px
        border-bottom-left-radius 5px
    }
    .verte {
        max-width 100%
        .verte__guide {
            width auto
            height auto
            max-width 100%
        }
        input {
            min-height 40px
            color: $color-primary;
            border: 1px solid $color-primary-light-8;
            background: $color-primary-light-7;
            border-top-right-radius 5px
            border-bottom-right-radius 5px
            margin-top: 0;
            padding: 6px;
            transition: 500ms;
            margin-bottom 3px
            box-sizing border-box
            font-weight 500
            max-width 161px
            font-size 14px
            text-transform uppercase
            &:focus {
                border: 1px solid $color-primary-light-6;
            }
        }
    }
    .text-input-container {
        input {
            text-align center
        }
    }

    .switch-input {
      
      &.enabled {
        .switch-status-label {
          
          color: $color-primary
        }
      }
    }

    .widget-positions {
        .widget-position {
            background: $color-primary-light-7;
            border: 1px solid $color-primary-light-8;
            box-sizing: border-box;
            border-radius: 3px;
            max-width 50px
            height 50px
            display flex
            align-items center
            justify-content center
            margin-right 9px
            margin-top 5px
            cursor pointer
            position relative
            transition: all .5s ease;
            text-align center
            &.selected {
                border: 1px solid $color-primary-light-5;
                .position {
                    border: 1px solid $color-primary-light-5;
                }
            }
            .position {
                background: #F1F2F6;
                border: 1px solid #F1F2F6;
                box-sizing: border-box;
                height 12px
                width 50px
                position absolute
                transition: all .5s ease;
                &.bottom {
                    bottom: -1px
                    border-bottom-left-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
                &.top {
                    top: -1px
                    border-top-left-radius: 3px;
                    border-top-right-radius: 3px;
                }
                &.bottom-centre {
                    bottom: -1px
                    width 34px
                }
                &.top-centre {
                    top: -1px
                    width 34px
                }
            }

            .position-label {
              position: absolute;
              bottom: -20px;
              font-size: 10px;
              width: 135%;
              text-align: center;
              color: $color-primary-light-5
            }
        }
    }

    .button-positions {
        .button-position {
            background: $color-primary-light-7;
            border: 1px solid $color-primary-light-8;
            box-sizing: border-box;
            border-radius: 3px;
            max-width 50px
            height 50px
            display flex
            align-items center
            justify-content center
            margin-right 9px
            margin-top 5px
            cursor pointer
            position relative
            transition: all .5s ease;
            text-align center
            &.selected {
                border: 1px solid $color-primary-light-5;
                .position {
                    border: 1px solid $color-primary-light-5;
                }
            }
            .position {
                background: #F1F2F6;
                border: 1px solid #F1F2F6;
                box-sizing: border-box;
                position absolute
                transition: all .5s ease;
                &.right-center {
                    height 22px
                    width 10px
                    right 0px
                    border-top-left-radius: 3px;
                    border-bottom-left-radius: 3px;
                }
                &.left-center {
                    height 22px
                    width 10px
                    left 0px
                    border-top-right-radius: 3px;
                    border-bottom-right-radius: 3px;
                }
                &.bottom-left {
                    height 10px
                    width  22px
                    left 4px
                    bottom 0px
                    border-top-right-radius: 3px;
                    border-top-left-radius: 3px;
                }
                &.bottom-right {
                    height 10px
                    width  22px
                    right 4px
                    bottom 0px
                    border-top-right-radius: 3px;
                    border-top-left-radius: 3px;
                }
            }

            .position-label {
              position: absolute;
              bottom: -20px;
              font-size: 10px;
              width: 135%;
              text-align: center;
              color: $color-primary-light-5
            }
        }
    }

    .switch-status-label {
      font-size 14px
      font-weight 500
      color: $color-primary-light-5
      height: 24px;
    }
}
</style>
